import { IncidentHistoryBaseDataProvider } from './IncidentHistoryBaseDataProvider';
import { IncidentHistoryResults, IncidentHistoryWebComponentSchema } from '../types';
import { getRequestDefaultOptions } from '../../../utils/request.utils';

export class IncidentHistoryNirvanaDataProvider extends IncidentHistoryBaseDataProvider {
  public static LIMIT = 100;

  async getDataForView(page: number): Promise<{ incidentsHistoryResults: IncidentHistoryResults }> {
    const incidentsHistoryResults = await this.getIncidentsHistory(page, this.dependencies.resourceId);

    return {
      incidentsHistoryResults,
    };
  }

  async getIncidentsHistory(page: number, incidentId: string): Promise<IncidentHistoryResults> {
    return this.dependencies.api.clients.IncidentsHistory.readRecords(
      {
        page: page,
        limit: IncidentHistoryNirvanaDataProvider.LIMIT,
        filter: [],
        incidentId: incidentId,
        isGzDemo: this.dependencies.isGzDemo,
      },
      getRequestDefaultOptions()
    );
  }
}
